import React, { useEffect, useRef, useState } from "react";
import "./allQuestions.css";
import "./review_all_question_type.css";
import Questionnobox from "../onreview_component/question_no_box/QuestionnoboxHW";
import UploadQuestion from "./UploadQuestion";
import { useLocation } from "react-router-dom";
import McqQuestion from "./McqQuestion";
import SuccessfullReview from "../SuccessfullOnreviewHW/SuccessfullReview";
import axios from "../../../../axios";
import moment from "moment";
import ErrorDialog from "../../../../Assesment/pages/Create_Assessment/create_published/ErrorDialogue";
import { DialogContent } from "@mui/material";
import ConfirmDialog from "../../../../Assesment/pages/Create_Assessment/create_published/ConfirmDialogue";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import {
  Box,
  Paper,
  Stack,
  Typography,
  Divider,
  Button,
  Chip,
} from "@mui/material";

const AllQuestions = () => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const assessmentReviewDialogRef = useRef();
  const [nextQuestion, setNextQuestion] = useState(0);
  const [areAllQuestionsAddressed, setAreAllQuestionsAddressed] =
    useState(true);
  //Added this state by kuldeep
  const { state } = useLocation();
  const navigate = useNavigate();
  const [studentResponse, setStudentResponse] = useState({});
  const [responseAnswers, setResponseAnswers] = useState([]);
  const [publishResult, setPublishResult] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [studentResults, setStudentResults] = useState([]);
  const [successfulReview, setSuccessfulReview] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  console.log(studentResponse);

  useEffect(() => {
    const flag = responseAnswers.some((ans) => ans.result.score === "");
    if (flag) {
      setAreAllQuestionsAddressed(true);
    } else {
      setAreAllQuestionsAddressed(false);
    }
  }, [responseAnswers]);

  useEffect(() => {
    const getStudentStatus = async () => {
      let res = await axios.get(
        `/api/v1/homework/studentStatus/homeworkId/${state.homework_id}/studentId/${state.student_id}`
      );

      res?.data?.data?.status === "completed" && getStudentResults();
    };
    const getStudentResults = async () => {
      let res = await axios.get(
        `/api/v1/homework/${state.homework_id}/studentResult/student/${state.student_id}/get`
      );
      res && setStudentResults(res.data.data.results);
    };

    const getStudentResponse = async () => {
      let result = {
        questionResponse: null,
        score: "",
        remark: "",
        correctScore: null,
      };
      try {
        let res = await axios.get(
          `/api/v1/homework/${state.homework_id}/studentResponse/student/${state.student_id}/getForTeacher`
        );
        res && setStudentResponse(res.data.data);
        const updatedAnswers = res?.data?.data?.answers.map((answer) => {
          return { ...answer, result };
        });
        setResponseAnswers(updatedAnswers);
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong for selected card!!");
      }
    };
    getStudentStatus();
    getStudentResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateHelper = (a) => {
    if (!a) return null;
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const submitResult = async () => {
    setInProgress(true);
    let results = [];
    let newResult = {
      teacher_id: teacher_id,
      student_id: state.student_id,
    };
    responseAnswers.map((answer) =>
      results.push({
        question_response_id: answer.result.questionResponse,
        comment: answer.result.remark.trim(),
        correct_score: answer.result.correctScore,
        obtained_marks: Number(answer.result.score),
      })
    );
    newResult.results = results;
    setConfirmPopup(false);
    try {
      let res = await axios.post(
        `/api/v1/homework/${state.homework_id}/studentResult/create`,
        newResult
      );
      if (res) {
        setSuccessfulReview(true);
        navigate("/onreviewstudentlistHW", {
          state: { homework_id: state.homework_id },
        });
      }

      // window.location.replace(`/onreviewstudentlistHW/${homework_id}`);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSubmitResult = async () => {
    if (areAllQuestionsAddressed) {
      setConfirmPopup(true);
      // Use a callback to ensure the dialog opens after the state update
      setTimeout(() => {
        assessmentReviewDialogRef.current.openDialog();
      }, 0);
    } else {
      await submitResult();
    }
  };

  const orangeBtnStyle = {
    backgroundColor: "#F28C28",
    color: "#ffffff",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: "8px",
    px: 3,
    "&:hover": {
      backgroundColor: "#d97706",
    },
  };

  return (
    <>
      {/* <div
        className="orange-scrollBar"
        style={{ height: "600px", overflowY: "scroll" }}
      >
        <>
          {confirmPopup && (
            <ConfirmDialog
              error={"Are you sure you want to submit?"}
              message={"You haven't marked all the questions yet!"}
              ref={assessmentReviewDialogRef}
              setState={setConfirmPopup}
              callFunction={submitResult}
            />
          )}
          {
            <>
              <div className="my-2 pb-4 mx-1 ">
                <div className="d-flex align-items-center  ">
                  <img
                    onClick={() =>
                      navigate("/onreviewstudentlistHW", {
                        state: { homework_id: state.homework_id },
                      })
                    }
                    style={{ cursor: "pointer" }}
                    src="/images/Back Arrow.svg"
                    alt=""
                  ></img>
                  <span
                    onClick={() => window.history.go(-2)}
                    className="published_hw_file_path1 mr-2"
                  >
                    &nbsp; Homework
                  </span>
                  <span
                    onClick={() => window.history.back()}
                    className="published_hw_file_path_title"
                    style={{ fontWeight: "600" }}
                  >
                    {studentResponse?.homework?.name
                      ? " / " + studentResponse?.homework?.name
                      : ""}{" "}
                    |&nbsp;
                  </span>
                  <span className="published_hw_file_path2">
                    {studentResponse?.student?.name || ""} HW
                  </span>
                </div>
                <div
                  className="mt-2 ms-1 published_tittle_heading"
                  style={{ width: "80%" }}
                >
                  {studentResponse?.homework?.description}
                </div>
                <div className="mt-2 ms-1  d-flex align-items-center ">
                  <span className=" open_ststus_hw py-1 mr-2 ">
                    {studentResults?.length > 0 ? "Completed" : "On review"}
                  </span>
                  <span className="published_hw_header_subject_name me-2">
                    {studentResponse?.homework?.subject_id?.name} |
                  </span>
                  <span className=" published_hw_header_subject_name mr-2">
                    Deadline
                  </span>
                  <span className="ms-2  scheduled_date_time mr-1 ">
                    {dateHelper(studentResponse?.submitted_on)}
                  </span>
                  <span className=" scheduled_date_time "></span>
                </div>
                {responseAnswers.length > 0 && !successfulReview ? (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="mt-3">
                        <Questionnobox
                          setNextQuestion={setNextQuestion}
                          nextQuestion={nextQuestion}
                          totalResponse={responseAnswers?.length}
                        />
                      </div>
                      <div
                        className="d-flex justify-content-end align-items-center gap-2"
                        style={{ width: "95.8%", marginRight: "62px" }}
                      >
                        {nextQuestion > 0 ? (
                          <button
                            disabled={nextQuestion == 0 ? true : false}
                            onClick={() => {
                              nextQuestion > 0 &&
                                setNextQuestion(nextQuestion - 1);
                            }}
                            className="onreviwe_preview_btn"
                          >
                            Previous
                          </button>
                        ) : (
                          <div></div>
                        )}
                        {nextQuestion !== responseAnswers?.length - 1 ? (
                          <button
                            onClick={() => {
                              nextQuestion < responseAnswers?.length &&
                                setNextQuestion(nextQuestion + 1);
                            }}
                            className="onreviwe_next_btn "
                          >
                            Next
                          </button>
                        ) : (
                          !studentResults?.length > 0 && (
                            <button
                              onClick={handleSubmitResult}
                              //style={{ width: "150px" }}
                              className="onreview_submit_btn align-item-end "
                              disabled={inProgress}
                            >
                              Submit
                            </button>
                          )
                        )}
                      </div>
                    </div>
                    {responseAnswers?.length > 0 &&
                    (responseAnswers[nextQuestion].question?.type?.name ===
                      "MCQ Type" ||
                      !responseAnswers[nextQuestion]?.question?.type
                        ?.is_manually_graded) ? (
                      <McqQuestion
                        questionNumber={nextQuestion}
                        response={responseAnswers[nextQuestion]}
                        setResponseAnswers={setResponseAnswers}
                        studentResults={studentResults}
                      />
                    ) : (
                      <UploadQuestion
                        questionNumber={nextQuestion}
                        response={responseAnswers[nextQuestion]}
                        setResponseAnswers={setResponseAnswers}
                        studentResults={studentResults}
                      />
                    )}
                  </>
                ) : (
                  successfulReview && (
                    <SuccessfullReview homework_id1={state.homework_id} />
                  )
                )}
              </div>
            </>
          }
          {publishResult ? (
            <></>
          ) : (
            inProgress && (
              <div className="loader_bg">
                <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" />
              </div>
            )
          )}
        </>
      </div> */}

      <div style={{ height: "100vh", background: "#f5f6fa" }}>
        {/* CONFIRM POPUP (UNCHANGED) */}
        {confirmPopup && (
          <ConfirmDialog
            error={"Are you sure you want to submit?"}
            message={"You haven't marked all the questions yet!"}
            ref={assessmentReviewDialogRef}
            setState={setConfirmPopup}
            callFunction={submitResult}
          />
        )}

        {/* ================= HEADER (NO SCROLL) ================= */}
        <Paper
          elevation={1}
          sx={{
            p: 2,
            borderRadius: 2,
            mx: 2,
            mt: 2,
          }}
        >
          <Stack spacing={1}>
            {/* BACK + PATH */}
            <Stack direction="row" alignItems="center" spacing={1}>
              <img
                src="/images/Back Arrow.svg"
                alt=""
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate("/onreviewstudentlistHW", {
                    state: { homework_id: state.homework_id },
                  })
                }
              />

              <Typography
                variant="body2"
                sx={{ cursor: "pointer", fontWeight: 500 }}
                onClick={() => window.history.go(-2)}
              >
                Homework /
              </Typography>

              <Typography variant="body2" fontWeight={600}>
                {studentResponse?.homework?.name}
              </Typography>

              <Typography variant="body2" color="text.secondary">
                | {studentResponse?.student?.name} HW
              </Typography>

              <Chip
                size="small"
                color={studentResults?.length > 0 ? "success" : "warning"}
                label={studentResults?.length > 0 ? "Completed" : "On Review"}
              />
              <Typography variant="body2">
                {studentResponse?.homework?.subject_id?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                | Deadline
              </Typography>
              <Typography variant="body2">
                {dateHelper(studentResponse?.submitted_on)}
              </Typography>
            </Stack>

            {/* DESCRIPTION */}
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ maxWidth: "80%", marginRight: "10px" }}
            >
              {studentResponse?.homework?.description}
            </Typography>
          </Stack>
        </Paper>

        {/* ================= QUESTION NAV ================= */}
        {responseAnswers.length > 0 && !successfulReview && (
          <Paper
            elevation={0}
            sx={{
              mx: 2,
              mt: 2,
              p: 1.5,
              borderRadius: 2,
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Questionnobox
                setNextQuestion={setNextQuestion}
                nextQuestion={nextQuestion}
                totalResponse={responseAnswers?.length}
              />

              <Stack direction="row" spacing={1}>
                {nextQuestion > 0 && (
                  <Button
                    variant="contained"
                    sx={orangeBtnStyle}
                    onClick={() => setNextQuestion(nextQuestion - 1)}
                  >
                    Previous
                  </Button>
                )}

                {nextQuestion !== responseAnswers.length - 1 ? (
                  <Button
                    variant="contained"
                    sx={orangeBtnStyle}
                    onClick={() => setNextQuestion(nextQuestion + 1)}
                  >
                    Next
                  </Button>
                ) : (
                  !studentResults?.length > 0 && (
                    <Button
                      variant="contained"
                      sx={{
                        ...orangeBtnStyle,
                        backgroundColor: "#16a34a", // green submit
                        "&:hover": { backgroundColor: "#15803d" },
                      }}
                      onClick={handleSubmitResult}
                      disabled={inProgress}
                    >
                      Submit
                    </Button>
                  )
                )}
              </Stack>
            </Stack>
          </Paper>
        )}

        {/* ================= QUESTIONS SCROLL AREA ================= */}
        <Box
          sx={{
            mx: 2,
            mt: 2,
            height: "calc(100vh - 320px)", // 👈 only questions scroll
            overflowY: "auto",
            pb: 2,
          }}
          className="orange-scrollBar"
        >
          {responseAnswers?.length > 0 && !successfulReview && (
            <>
              {responseAnswers[nextQuestion]?.question?.type?.name ===
                "MCQ Type" ||
              !responseAnswers[nextQuestion]?.question?.type
                ?.is_manually_graded ? (
                <McqQuestion
                  questionNumber={nextQuestion}
                  response={responseAnswers[nextQuestion]}
                  setResponseAnswers={setResponseAnswers}
                  studentResults={studentResults}
                />
              ) : (
                <UploadQuestion
                  questionNumber={nextQuestion}
                  response={responseAnswers[nextQuestion]}
                  setResponseAnswers={setResponseAnswers}
                  studentResults={studentResults}
                />
              )}
            </>
          )}

          {successfulReview && (
            <SuccessfullReview homework_id1={state.homework_id} />
          )}
        </Box>

        {/* ================= LOADER ================= */}
        {inProgress && !publishResult && (
          <div className="loader_bg">
            <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" />
          </div>
        )}
      </div>
    </>
  );
};

export default AllQuestions;
